import NavBar from "../NavBar/navbar";
import React, {useState} from 'react';
import { useLocation } from "react-router-dom";
import axios from 'axios';
import {Table} from "antd";
import { useNavigate } from 'react-router-dom';
import './proposallistview.css';
import { getTokenUser } from "../../helper/token";

function Proplistview (){


    //#region State Management
    const [tableDataSource,setDataSource] = useState([]);
    const state = useLocation();
    const SERVER_URL = process.env.REACT_APP_PROD_SERVER_URL;
    //const [tableState,setTableState] = useState(state.state);
    const[tableSize,setTableSize] = useState("col-12");
    const [customerFilters, setCustomerFilter] = useState([]);
    const [loggedInUser,setLoggedInUser] = useState(getTokenUser());
    axios.defaults.headers.common['Authorization'] = loggedInUser.token;
    //const showtable = 1;
    //#endregion

    //#region Table column definitions
    // const CustomerColumns =[{
    //     title:"Customer Name",
    //     dataIndex:"customer_name",
    //     filters: customerFilters,
    //     filterMode: 'tree',
    //     filterSearch: true,
    //     onFilter: (value, record) => record.customer_name.startsWith(value),
    //     width: '30%',
    //     //render: (text, record, index) => <div><p className="record-name" onClick = {(e) => {onTableItemNavigate(record.key+"-"+"CUSTOMER")}}>{record.customer_name}</p></div>
    // },
  
    const ProposalColumns=[{
        title:"Proposal Name",
        dataIndex:"proposal_name",
        //render: (text, record, index) => <div><p className="record-proposal" onClick = {(e) => {onTableItemNavigate(record.key+"-"+"PROPOSAL")}}>{record.proposal_name}</p></div>
    },
    {
        title:"Proposal Date From",
        dataIndex:"proposal_date_from"
    },
    {
        title:"Proposal Date To",
        dataIndex:"proposal_date_to"
    },
    {
        title:"Proposal Unit QTY",
        dataIndex:"proposal_unit_qty"
    },
    {
        title:"Proposal Unit Value",
        dataIndex:"proposal_unit_value"
    },
    {
        title:"Proposal SubTotal Exc",
        dataIndex:"proposal_subtotal_exc"
    },
    {
        title:"Proposal SubTotal Inc",
        dataIndex:"proposal_subtotal_inc"
    },
    {
        title:"Proposal Frequency QTY",
        dataIndex:"proposal_frequency_qty"
    },
    {
        title:"Proposal Frequency Type",
        dataIndex:"proposal_frequency_type"
    },
    {
        title:"Proposal Total Exc",
        dataIndex:"proposal_total_exc"
    },
    {
        title:"Proposal Total Inc",
        dataIndex:"proposal_total_inc"
    },
    {
        title:"Proposal Document",
        dataIndex:"invoice_description",
        render: (text, record, index) => <div><a>www.Sharepoint.co.za/189732y128974y132.jpg</a></div>
    },]
    //#endregion
    const onChange = (pagination, filters, sorter, extra) => {
        console.log('params', pagination, filters, sorter, extra);
      };


    //#region region UI Population
    React.useEffect(()=>{
        try {
            //console.log()
            console.log(state);
            axios.get(SERVER_URL+'/api/Proposal/GetAllProposals')
                .then((response) => {
                    console.log(response);
                    const tempData = [];
                    let tempProp={};
                    response.data.forEach(element => {
                        console.log(element.PropTotalExc);
                        console.log(element.PropId);
                        tempProp = {key:element.PropId,
                            proposal_name:element.PropName,
                            proposal_date_from:element.PropDateFrom.substring(0,10),
                            proposal_date_to:element.PropDateTo.substring(0,10),
                            proposal_notes:element.PropNotes,
                            proposal_status:(element.PropStatus===1?"Active":"Inactive"),
                            proposal_unit_qty:element.PropUnitQty,
                            proposal_unit_value:element.PropUnitValue.toFixed(2),
                            proposal_subtotal_exc:element.PropSubTotalExc.toFixed(2),
                            proposal_subtotal_inc:element.PropSubTotalInc.toFixed(2),
                            proposal_frequency_qty:element.PropFreqQty,
                            proposal_frequency_type:(element.PropFreqType === "1" ? "Daily" : element.PropFreqType === "2" ? "Weekly" : element.PropFreqType === "3" ? "Monthly" : "N/A"),
                            proposal_total_exc:element.PropTotalExc.toFixed(2),
                            proposal_total_inc:element.PropTotalInc.toFixed(2),
                            proposal_type:'server'}
                            tempData.push(tempProp);
                        });
                        setDataSource(tempData);
                });
        } catch (error) {
            console.log(error);
        }
    },[]);
    //#endregion 

    return(
        <div>
            <NavBar/>
            <div id="proposallistview-body">
            <h1>Proposals</h1>
                <div className={tableSize}>
                    <div id="home-table-container">
                        <Table 
                            id="home-table" 
                            pagination={{ position: ["none", "none"] }} 
                            bordered="true" 
                            columns={ProposalColumns} 
                            dataSource={tableDataSource}
                            rowClassName="row-class-test">
                        </Table>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Proplistview